import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ResetPasswordComponent } from './../components/custompassword/resetpassword.component';
import { PrintInvoiceComponent } from './print-invoice.component';

const routes: Routes = [
    { path: '', component: PrintInvoiceComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PrintInvoiceRoutingModule {
}